import React from "react";
import AdminResponseContainer from "../Admin/AdminResponseContainer";
import ResponseContainer from "../Employee/ResponseContainer";

const CRRAnswerModule = ({
  has_question_subcategory,
  subcategories,
  previous_submission,
  id,
  isAdminView,
  setAnswer,

  ...rest
}) => {
  return (
    <div className="question-answers">
      {has_question_subcategory ? (
        <>
          {[...subcategories]
            .sort((a, b) => a.category_id - b.category_id)
            .map((cat, index) =>
              isAdminView ? (
                <AdminResponseContainer
                  key={index}
                  categoryData={cat}
                  prevAnswer={previous_submission}
                  questionId={id}
                  {...rest}
                />
              ) : (
                <ResponseContainer
                  questionId={id}
                  key={index}
                  setAnswer={setAnswer}
                  categoryData={cat}
                  prevAnswer={previous_submission}
                  {...rest}
                />
              )
            )}
        </>
      ) : isAdminView ? (
        <AdminResponseContainer
          prevAnswer={previous_submission[0]}
          questionId={id}
          {...rest}
        />
      ) : (
        <ResponseContainer
          questionId={id}
          setAnswer={setAnswer}
          prevAnswer={previous_submission[0]}
          {...rest}
        />
      )}
    </div>
  );
};

export default CRRAnswerModule;
